import { ErrorCode } from '@/features/print/constants'

export class PrinterError extends Error {
    public readonly code: ErrorCode
    public readonly details?: Record<string, any>
    public readonly cause?: Error

    constructor(code: ErrorCode, details?: Record<string, any>, cause?: Error) {
        super(code, { cause })
        this.code = code
        this.details = details
        this.cause = cause
    }
}
